// Run page checks before changing the login token/current site.
const guards = new Set()
export function registerSiteChangeGuard(guard) {
  guards.add(guard)
  return () => guards.delete(guard)
}
export async function canChangeSite() {
  for (const guard of [...guards]) if (!await guard()) return false
  return true
}
